import styled from "styled-components";

import { PageContainer } from "app/pages/industry-analysis/common/styledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { PreviewBody } from "./components/Body";
import { PreviewFooter } from "./components/Footer";
import { GroupName } from "./components/GroupName";
import { PreviewSubtitle } from "./components/Subtitle";

const Container = styled(PageContainer)`
    padding: 20px 24px 16px 24px;
    box-sizing: border-box;
    width: 480px;
    gap: 12px;
`;

export const KeywordListComposerPreview = ({ onCloseConfirm }: { onCloseConfirm: VoidFunction }) => {
    return (
        <Container>
            <FlexColumn gap="8px">
                <GroupName />
                <PreviewSubtitle />
            </FlexColumn>
            <FlexColumn gap="16px">
                <PreviewBody />
                <PreviewFooter onClose={onCloseConfirm} />
            </FlexColumn>
        </Container>
    );
};
